// lib/logger.ts
type LoggerMethod = (...args: unknown[]) => void;

const logger = {
  info: ((...args: unknown[]) => {
    if (typeof window === 'undefined') {
      // Server-side logging
      import('winston').then((winston) => {
        const serverLogger = winston.default.createLogger({
          level: process.env.LOG_LEVEL || 'info',
          format: winston.default.format.json(),
          transports: [new winston.default.transports.Console()],
        });
        serverLogger.info(args);
      });
    } else {
      // Browser-safe logging
      console.log(...args);
    }
  }) as LoggerMethod,

  warn: ((...args: unknown[]) => {
    if (typeof window === 'undefined') {
      // Server-side logging
      import('winston').then((winston) => {
        const serverLogger = winston.default.createLogger({
          level: process.env.LOG_LEVEL || 'info',
          format: winston.default.format.json(),
          transports: [new winston.default.transports.Console()],
        });
        serverLogger.warn(args);
      });
    } else {
      // Browser-safe logging
      console.warn(...args);
    }
  }) as LoggerMethod,

  error: ((...args: unknown[]) => {
    if (typeof window === 'undefined') {
      // Server-side logging
      import('winston').then((winston) => {
        const serverLogger = winston.default.createLogger({
          level: process.env.LOG_LEVEL || 'info',
          format: winston.default.format.json(),
          transports: [new winston.default.transports.Console()],
        });
        serverLogger.error(args);
      });
    } else {
      // Browser-safe logging
      console.error(...args);
    }
  }) as LoggerMethod,
};

export default logger;
